module.exports = __webpack_public_path__ + "static/media/status_5.0c1a13e4.svg";